import { makeStyles } from '../styles';
export const useButtonLinkStyles = makeStyles(() => ({
    root: {
        textAlign: 'center',
        '&:hover': {
            textDecoration: 'none',
        },
    },
}));
//# sourceMappingURL=buttonLink.styles.js.map